import { z } from "zod";

import {
	LiEventInclusionStatus,
	LiEventLocationType,
	LiEventScrapeStatus,
} from "@/enum/scrape-enum";
import { MetaDataSchema } from "@/schemas/meta-data";
import { ERROR_TYPE } from "@/utils";

import { LiEventEntryAttendeeSchema } from "./liEventEntryAttendee";

const { REQUIRED } = ERROR_TYPE;

export const LiEventEntrySchema = z.object({
	id: z.number(),
	name: z.string().min(2, { message: REQUIRED }).trim(),
	url: z.string().min(2, { message: REQUIRED }).trim(),
	description: z.string().trim(),
	companyName: z.string().trim(),
	attendees: z.number().nullable(),
	eventAt: z.string().nullable(),
	eventTill: z.string().nullable(),
	type: z.nativeEnum(LiEventLocationType),
	status: z.nativeEnum(LiEventScrapeStatus),
	liEventEntryAttendees: z.array(LiEventEntryAttendeeSchema).optional(),
	ignorePattern: z.boolean(),
	liEvent: z.any(),
	inclusionStatus: z.nativeEnum(LiEventInclusionStatus),
});

export const LiEventEntrysResponseSchema = z.object({
	data: z.array(LiEventEntrySchema),
	meta: MetaDataSchema,
});

export const LiEventEntrysWithCountResponseSchema = z.object({
	data: z.array(LiEventEntrySchema),
	meta: MetaDataSchema,
	count: z.object({
		DRAFT: z.number(),
		ADDED: z.number(),
		UNSURE: z.number(),
	}),
});

export type LiEventEntry = z.infer<typeof LiEventEntrySchema>;

export type LiEventEntrysResponse = z.infer<typeof LiEventEntrysResponseSchema>;

export type LiEventEntrysWithCountResponse = z.infer<typeof LiEventEntrysWithCountResponseSchema>;
